import { getAppConfig } from '../utils/config'
import { HttpService, RequestOptions } from './services/api'

const { clientId, api } = getAppConfig()

class CheckoutHttpService extends HttpService {
  override async request<Req, Resp>(url: string, method: string, data: Req): Promise<Resp | undefined> {
    const options: RequestOptions = {}

    if (url.includes(api.customerRequest) || url === `${api.checkout}/orders/cancel-checkout-by-customer-request-id`) {
      options.headers = { authorization: `Client ${clientId}` }

      if (method.toLowerCase() === 'post' && url === `${api.customerRequest}/requests`) {
        options.credentials = 'omit'
      }
    }

    return super.request(url, method, data, options)
  }
}

const getCheckoutHttpService = (): HttpService => new CheckoutHttpService()
export const checkoutHttp = getCheckoutHttpService()

export const createCheckoutApi = (): HttpService => checkoutHttp
